// CSS custom properties so values respect light/dark themes automatically.
export const WALLET_COLOR_BY_CURRENCY: Record<string, string> = {
  COP: "var(--primary)",
  MXN: "#c084fc",
  BRL: "#34d399",
  ARS: "#fbbf24",
  PEN: "#f87171",
  CLP: "#60a5fa",
  USD: "#22c55e",
  EUR: "#3b82f6",
  USDT: "#22c55e",
  USDC: "#0ea5e9",
};

export const getColorForCurrency = (currency: string): string =>
  WALLET_COLOR_BY_CURRENCY[currency.toUpperCase()] ?? "var(--primary)";
